// import C from './config.js'
import M from './common'

// http请求方法
let load = M.load

let api = {
  /**
   * Verify Custom Info
   * @param params
   * @param callback
   */
  verifyCustom (params, callback) {
    let url = 'custom/verify'
    load(url, params, (data) => {
      callback(data)
    }, 'get')
  },
    /**
   * Verify user Info
   * @param params
   * @param callback
   */
  verifyUser (params, callback) {
    let url = 'user/verify'
    load(url, params, (data) => {
      callback(data)
    }, 'get')
  },
    /**
   * 用户绑定设备或旧账号设备
   * @param params
   * @param callback
   */
  bindDevice (params, callback) {
    let url = '/customers' + (params.customerId ? `/${params.customerId}` : '')+'/bind_device'
    load(url, params, (data) => {
      callback(data)
    }, 'POST')
  },


  /**
   * 查询设备列表
   * @param params
   * @param callback
   */
  loadDevice (params, callback) {
    let url = '/devices' + (params.device_id ? `/${params.device_id}` : '')
    load(url, params, (data) => {
      callback(data)
    }, 'get')
  },


  /**
   * 查询设备数据
   * @param params
   * @param callback
   */
  loadDeviceData (params, callback) {
    let url = `/devices/${params.device_id}/data`
    load(url, params, (data) => {
      callback(data)
    }, 'get')
  },
    /**
   * 查询设备配置参数
   * @param params
   * @param callback
   */
  loadDeviceConf (params, callback) {
    let url = `/devices/${params.device_id}/conf`
    load(url, params, (data) => {
      callback(data)
    }, 'get')
  },
  /**
   *设置设备配置参数(多选项)
   * @param {Object} params
   * @param {function} callback
   */
  setDeviceConf(params,callback){
    let url =`/devices/${params.device_id}/conf`
    load(url,params,(data)=>{
      callback(data)
    },'post')
  },
    /**
     * 设置设备Setting
     * @param params
     * @param callback
     */
    loadDeviceSetting (params, callback) {
        let url = `/devices/${params.device_id}/settings`
        load(url, params, (data) => {
            callback(data)
        }, 'get')
    },
    /**
     * 设置设备Setting
     * @param params
     * @param callback
     */
    setDeviceSetting (params, callback) {
        let url = `/devices/${params.device_id}/settings`
        load(url, params, (data) => {
            callback(data)
        }, 'post')
    },
    /**
     * 设置设备名称表
     * @param params
     * @param callback
     */
    loadDeviceName (params, callback) {
        let url = `/devices/${params.device_id}/name`
        load(url, params, (data) => {
            callback(data)
        }, 'get')
    },
    /**
     * 设置设备Name
     * @param params
     * @param callback
     */
    setDeviceName (params, callback) {
        let url = `/devices/${params.device_id}/name`
        load(url, params, (data) => {
            callback(data)
        }, 'get')
    },
    /**
     * 发送设备短消息
     * @param params
     * @param callback
     */
    setDeviceMsg (params, callback) {
        let url = `/devices/${params.device_id}/setinfo `
        load(url, params, (data) => {
            callback(data)
        }, 'post')
    },

    /**
   *导出Excel文件
   * @param {Object} params
   * @param {function} callback
   */
  exportProExcel(params,callback){
    let url =`/devices/${params.device_id}/pro_export`
    load(url,params,(data)=>{
      callback(data)
    },'get')
  },

  /**
   * 用户登出
   * @param {Object} params
   * @param {function} callback
   */
  logout(params,callback){
    let url =`auth/logout`
    load(url,params,(data)=>{
      callback(data)
    },'post')
  },


    /**
   * 微信网页授权获取用户信息
   * @param {Object} params
   * @param {function} callback
   */
  wxGetAuthToken(params,callback){
    let url =`wechat_authorize/code`
    console.log(params)
    load(url,params,(data)=>{
      callback(data)
    },'GET')
  },

      /**
   * 设置风机频率
   * @param {Object} params
   * @param {function} callback
   */
  setFrequency(params,callback){
    let url =`devices/${params.device_sn}/frequency`
    console.log(params)
    load(url,params,(data)=>{
      callback(data)
    },'POST')
  },

}
export default api



// WEBPACK FOOTER //
// ./src/lib/api.js